import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import VehicleTitle from 'commons-vehicle/Vehicle/components/Overview/VehicleTitle/VehicleTitle.jsx';
import TileTag from 'commons-vehicle/Vehicle/components/TileTag/TileTag.jsx';
import PaymentDetail from 'commons-vehicle/Vehicle/components/Payment/PaymentDetail/PaymentDetail.jsx';

import 'commons-vehicle/Vehicle/components/Overview/Overview.scss';

const VehicleSummary = ({
    isUsed,
    optionalButton,
    packageName,
    purchaseMethods,
    taxCodes,
    title,
    vehicleStockNo,
    isReserved,
}) => {
    return (
        <div className="vehicle-overview">
            <TileTag
                shouldRender={isReserved}
                icon="icon-lock"
                background="#F5273F"
                color="#fff"
                text={LocaleService.t('VEHICLE_STATUS.RESERVED')}
            />
            <VehicleTitle title={title} packageName={packageName} vehicleStockNo={vehicleStockNo} />
            <PaymentDetail purchaseMethods={purchaseMethods} isUsed={isUsed} taxCodes={taxCodes} />
            {optionalButton}
        </div>
    );
};

VehicleSummary.defaultProps = {
    isReserved: false,
    packageName: '',
    vehicleStockNo: '',
    optionalButton: noop,
};

VehicleSummary.propTypes = {
    isUsed: PropTypes.bool.isRequired,
    optionalButton: PropTypes.func,
    packageName: PropTypes.string,
    vehicleStockNo: PropTypes.string,
    purchaseMethods: PropTypes.shape({
        cashPurchase: PropTypes.object.isRequired,
        financing: PropTypes.object.isRequired,
    }).isRequired,
    taxCodes: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isReserved: PropTypes.bool,
};

VehicleSummary.displayName = 'VehicleSummary';

export default VehicleSummary;



// WEBPACK FOOTER //
// ./src/Vehicle/components/Overview/VehicleSummary/VehicleSummary.jsx